import React, { useEffect, useState} from "react";
import { useSearchParams } from "react-router-dom";
import "./ReportInvoice.css";

export default function ReportInvoice({ hideUI }) {
  const [searchParams] = useSearchParams();
  const [report, setReport] = useState(null);
  const email = searchParams.get("email")
  const paymentData = searchParams.get("paymentData") ? JSON.parse(searchParams.get("paymentData")) : null;
  const reportType = searchParams.get("type"); // A or B

useEffect(() => {
    console.log("Search params on invoice page:", Object.fromEntries(searchParams.entries()));
  try {
    const encoded = searchParams.get("report");
    if (!encoded) return;

    // ✅ browser-safe decode (NO Buffer)
    const jsonString = atob(decodeURIComponent(encoded));
    const decoded = JSON.parse(jsonString);

    setReport(decoded);
  } catch (err) {
    console.error("❌ Failed to decode report:", err);
    setReport(null);
  }
}, [searchParams]);


  // Helper to format contact numbers to start with +91 if they are standard 10-digit Indian numbers
  const formatContact = (contact) => {
    if (!contact) return "";
    const cleaned = contact.trim();
    if (cleaned.startsWith("+")) return cleaned;
    return `+91 ${cleaned}`;
  };

  // Helper to map payment method to standard label
  const getPaymentModeLabel = (mode) => {
    if (!mode) return "Net banking";
    switch (mode.toLowerCase()) {
      case "card": return "Card";
      case "upi": return "UPI";
      case "netbanking": return "Net banking";
      case "wallet": return "Wallet";
      default: return mode.charAt(0).toUpperCase() + mode.slice(1);
    }
  };

  // ✅ pricing
  const price = paymentData?.amount_rupees ? Number(paymentData.amount_rupees) : (reportType === "A" ? 199 : 299);
  const tax = 0;
  const total = price + tax;

  const now = paymentData?.created_at ? new Date(paymentData.created_at) : new Date();

  const date = now
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    })
    .toUpperCase();

  const time = now.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });

  const created = new Date(report?.created_at || report?.createdAt || Date.now());
  const reportDate = created.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata", // Forces IST
  }).replace(/\b[a-z]/gi, m => m.toUpperCase());

  const reportTime = created.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata", // Forces IST
  });

  const mind = searchParams.get("mind") === "true";

  return (
    <div className="invoice-wrapper">
      <div className="invoice-section">
        {/* HEADER */}
        <div className="invoice-header">
          <h1 className="invoice-title">INVOICE</h1>

          <div className="logo-container">
            <img src="/image/logo.png" alt="Marsmate AI Logo" className="main-logo" />
          </div>
        </div>

        {/* TOP INFO */}
        <div className="invoice-top">
          <div className="billing-info">
            <p className="label">Invoice to :</p>
            <h2 className="client-name">{paymentData?.customer_name || report?.full_name || "Customer"}</h2>
            <p className="client-detail">{paymentData?.customer_contact ? formatContact(paymentData.customer_contact) : "+123-456-7890"}</p>
            <p className="client-detail">{paymentData?.customer_email || email || "info@marsmateai.com"}</p>
            <p>
              <strong>Report Type :</strong>{" "}
              {mind ? "Mind Mapping" : "Idea Validation"}
            </p>
          </div>

          <div className="invoice-meta">
            <p><strong>Invoice No </strong><span className="colon-report-inv-id">:</span> {paymentData?.invoice_id || "PENDING"}</p>
            <p><strong>Invoice Date </strong> <span className="colon-report-inv-date">:</span> {date}</p>
            <p><strong>Invoice Time </strong>: {time}</p>
          </div>
        </div>

        {/* TABLE */}
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Service</th>
              <th>Date</th>
              <th>Time</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{mind ? "Mind Mapping" : "Idea Validation"} Report - {reportType}</td>
              <td>{reportDate}</td>
              <td>{reportTime}</td>
              <td>{price.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        {/* SUMMARY SECTION */}
        <div className="summary-wrapper">
          <div className="payment-method">
            <h3 className="section-title">Payment Details</h3>
            <p><strong>Order ID </strong>   <span className="colon-report-order-id">:</span> {paymentData?.razorpay_order_id || "PENDING"}</p>
            <p><strong>Payment ID </strong>  <span className="colon-report-pay-id">:</span> {paymentData?.razorpay_payment_id || "PENDING"}</p>
            <p><strong>Payment Mode </strong>: {getPaymentModeLabel(paymentData?.mode)}</p>
          </div>

          <div className="totals-box">
            <div className="total-final">
              <span>Total :</span>
              <span>{total.toFixed(2)}</span>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="invoice-footer">
          <div className="contact-info">
            <h3 className="section-title">Contact Us</h3>
             <p>info@marsmateai.com</p>
            <p>+91-9494075914</p>
            <p>8-2-293, Plot No - 26, 2nd Floor,<br />
              Banjara Hills, Srinagar Colony,<br />
              Khairatabad, Hyderabad - 500073, Telangana
            </p>
            <p>https://marsmateai.com</p>
          </div>

          <div className="signature-block">
            <img className="signatory-name" src="/image/signature.png" alt="founder-sign"/>
            <p className="signatory-role">Founder and Managing Director</p>
          </div>
        </div>
      </div>
    </div>
  );
}
